import { Component, OnInit } from '@angular/core';

import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';

import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { TwTcAccionesViewModel } from '../accionesperfiltipoestado/accionesperfiltipoestado.types';
import { WAccionesPerfilTipoEstadoExViewModel } from './accionesperfiltipoestadoEx.types';
import { AccionesPerfilTipoEstadoExService } from './accionesperfiltipoestadoEx.service';
import { EnumIdsTcTipoModulo } from '../../../_importacion/solicitudes/types/enum';
import { SubTipoSolicitudExViewModel } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';
import { EnumIdsTcTipoSolicitudEx } from '../../../_exportacion/solicitudes/types/enum';

@Component({
    selector: 'app-accionesperfiltipoestadoex-edit',
    templateUrl: './accionesperfiltipoestadoEx-edit.component.html',
})
export class AccionesPerfilTipoEstadoExEditComponent extends ComponentBase implements OnInit {
    /** accionesperfiltipoestado-edit ctor */

    editMode: boolean;
    editTitle = 'Nuevo';

    listAccionesEx: Tc[];
    listPerfil: Tc[];
    listEstadoEx: Tc[];
    listTipoEx: Tc[];
    listSubTipoSolicitudEx: SubTipoSolicitudExViewModel[];

    accion: TwTcAccionesViewModel;
    accionesPerfilTipoEstadoEx: WAccionesPerfilTipoEstadoExViewModel;
    visibilitySpinner = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private accionesPerfilTipoEstadoExService: AccionesPerfilTipoEstadoExService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.accionesPerfilTipoEstadoEx = new WAccionesPerfilTipoEstadoExViewModel();
        this.accion = new TwTcAccionesViewModel();
    }

    ngOnInit(): void {
        this.globalService.getAccionesByModulo(EnumIdsTcTipoModulo.ID_EXPORTACION).subscribe(res => {
            this.listAccionesEx = res;
        });
        this.globalService.getPerfilesUsuario().subscribe(res => {
            this.listPerfil = res;
        });
        this.globalService.getEstadoSolicitudExpor().subscribe(res => {
            this.listEstadoEx = res;
        });
        this.globalService.getTipoSolicitudExpor().subscribe(res => {
            this.listTipoEx = res;
        });

        this.createForm();
        // let id = +this.activatedRoute.snapshot.params['id'];
    }

    createForm(): void {
        this.form = this.fb.group({
            IdAccion: [null, Validators.required],
            IdPerfil: [null, Validators.required],
            IdEstado: null,
            IdTipo: null,
            IdSubTipo: null,
            Edicion: [false, Validators.required],
        });
    }

    updateForm(): void {
        this.form.setValue({
            IdAccion: this.accionesPerfilTipoEstadoEx.IdAccion,
            IdPerfil: this.accionesPerfilTipoEstadoEx.IdPerfil,
            IdEstado: this.accionesPerfilTipoEstadoEx.IdEstado,
            IdTipo: this.accionesPerfilTipoEstadoEx.IdTipo,
            IdSubTipo: this.accionesPerfilTipoEstadoEx.IdSubTipo,
            Edicion: this.accionesPerfilTipoEstadoEx.Edicion,
        });
    }

    onSelectAccion(): void {
        if (this.form.value.IdAccion == null) {
            this.form.controls['IdEstado'].enable();
            this.form.controls['IdTipo'].enable();
            this.form.controls['IdSubTipo'].enable();
            this.form.controls['IdSubtipo'].enable();
            this.form.patchValue({
                IdEstado: null,
                IdTipo: null,
                IdSubtipo: null,
            });
        } else {
            this.accionesPerfilTipoEstadoExService.getAccionById(this.form.value.IdAccion).subscribe(result => {
                this.accion = result;
                if (this.accion.Estado) {
                    this.form.controls['IdEstado'].enable();
                } else {
                    this.form.controls['IdEstado'].disable();
                    this.form.patchValue({
                        IdEstado: null,
                    });
                }
                if (this.accion.Tipo) {
                    this.form.controls['IdTipo'].enable();
                    this.form.controls['IdSubTipo'].enable();
                } else {
                    this.form.controls['IdTipo'].disable();
                    this.form.controls['IdSubTipo'].enable();
                    this.form.patchValue({
                        IdTipo: null,
                    });
                }
            });
        }
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let accionesPerfilTipoEstadoEx = new WAccionesPerfilTipoEstadoExViewModel();

        //accionesPerfilTipoEstado.IdModulo = this.form.value.IdModulo;
        accionesPerfilTipoEstadoEx.IdAccion = this.form.value.IdAccion;
        accionesPerfilTipoEstadoEx.IdPerfil = this.form.value.IdPerfil;
        accionesPerfilTipoEstadoEx.IdEstado = this.form.value.IdEstado;
        accionesPerfilTipoEstadoEx.IdTipo = this.form.value.IdTipo;
        accionesPerfilTipoEstadoEx.IdSubTipo = this.form.value.IdSubTipo;
        accionesPerfilTipoEstadoEx.Edicion = this.form.value.Edicion;

        accionesPerfilTipoEstadoEx.Id = this.accionesPerfilTipoEstadoEx.Id;

        if (this.editMode) {
            this.accionesPerfilTipoEstadoExService.editAccionesPerfilTipoEstado(accionesPerfilTipoEstadoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Permiso de Acción modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.accionesPerfilTipoEstadoExService.createAccionesPerfilTipoEstado(accionesPerfilTipoEstadoEx).subscribe({
                next: () => {
                    this.addSuccessMessage('Permiso de Acción añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onSelectTipoSolicitudEx(): void {
        if (this.form.value.IdTipo === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS);
            });
        } else if (this.form.value.IdTipo === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION);
            });
        } else {
            this.listSubTipoSolicitudEx = [];
        }
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/permisos/accionesperfiltipoestadoEx']);
    }
}
